module.exports = __webpack_public_path__ + "static/media/share__mix.a11951bf.svg";